import { render, staticRenderFns } from "./Wp_pdd_select_base.vue?vue&type=template&id=2a92d929&scoped=true&"
import script from "./Wp_pdd_select_base.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_select_base.vue?vue&type=script&lang=js&"
import style0 from "./Wp_pdd_select_base.vue?vue&type=style&index=0&id=2a92d929&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a92d929",
  null
  
)

export default component.exports